import { cn } from "../../lib/cn.js";

export function Label({ className, ...props }: React.ComponentProps<"label">): React.JSX.Element {
  return (
    <label
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none",
        "peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
